import { Box, Container, Grid, Typography } from "@mui/material"
import SecurityIcon from "@mui/icons-material/Security";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import PublicIcon from "@mui/icons-material/Public";
import LockIcon from "@mui/icons-material/Lock";
import UmbrellaIcon from "@mui/icons-material/Umbrella";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import TradingDetailsBox from "./Utilities/TradingDetailsBox";
import { Helmet } from "react-helmet-async";

  const items = [
    {
      icon: <SecurityIcon sx={{ fontSize: 40, color: "#172543" }} />,
      title: "Market Leading Insurance",
      description:
        "The Company has made further efforts to safeguard its liabilities against Clients and other third parties with a Civil Liability insurance program for a limit of €5,000,000, which includes market leading coverage against errors, omissions, negligence, fraud and various other risks that may lead to financial loss.",
    },
    {
      icon: <PublicIcon sx={{ fontSize: 40, color: "#172543" }} />,
      title: "Industry leader; leading financial safety",
      description:
        "The HC Finvest brand has become a global leader in online trading, specializing in forex, derivatives on US and UK stocks, commodities, spot metals, and indices. Client fund security has been a part of our philosophy alongside unmatched trading conditions and customer support.",
    },
    {
      icon: <AccountBalanceIcon sx={{ fontSize: 40, color: "#172543" }} />,
      title: "Accounts with major banks",
      description:
        "HC Finvest made the decision to only use major global banks. The strength and international standing of the HC Finvest brand enables the company to provide liquidity through major banks.",
    },
    {
      icon: <LockIcon sx={{ fontSize: 40, color: "#172543" }} />,
      title: "Segregation of funds",
      description:
        "Clients’ funds are received into bank accounts separate from those used by the company. These funds are off the balance sheet and cannot be used to pay back creditors in the unlikely event of the company’s default.",
    },
    {
      icon: <ShowChartIcon sx={{ fontSize: 40, color: "#172543" }} />,
      title: "Negative balance protection",
      description:
        "Volatility often occurs in the market. HC Finvest policy of negative balance protection means that even under highly volatile conditions, no client is responsible for paying back a negative balance.",
    },
    {
      icon: <UmbrellaIcon sx={{ fontSize: 40, color: "#172543" }} />,
      title: "Risk management",
      description:
        "The Company continually identifies, assesses, and monitors each type of risk associated with its operations. This ensures effective policies, procedures, and arrangements to meet financial and capital requirements at any time.",
    },
  ];


const SecurityOfFunds = () => {
    return (
        <>

            <Helmet>
              <link rel="canonical" href="https://www.hcfinvest.com/securityOfFunds" />
            </Helmet>

                <Container
        sx={{ backgroundColor: "#fff" }}
        maxWidth={false}
        disableGutters
      >
        <ScrollToTopButton/>
        {/* Bannner Box Start */}

        <Box
          className="page-hero"
          sx={{
            height: { xs: "320px", sm: "400px", md: "475px" },
            backgroundImage: `url('/Images/FundSecurityImages/Newhedgecapitalsimage_security of funds.jpg')`,
            marginBottom: "30px",
          }}
        >
          <div className="page-hero-content">
            <h1 className="page-hero-title">Security Of Funds</h1>
            <p className="page-hero-subtitle">
              Your Fund's Security is Our Top Priority
            </p>
          </div>
        </Box>

        {/* Banner Box End */}

        <Box sx={{ py: { xs: 5, md: 7 }, backgroundColor: "#f9fafc" }}>
          <Container maxWidth="lg">
            <Grid container spacing={4}>
              {items.map((item, index) => (
                <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                  <Box
                    sx={{
                      height: "100%",
                      p: 4,
                      backgroundColor: "#fff",
                      borderRadius: "16px",
                      border: "1px solid #f0f0f0",
                      boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background:
                          "linear-gradient(135deg, rgba(29,44,97,0.12) 0%, rgba(58,90,168,0.12) 100%)",
                        mb: 2,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 700, color: "#172543", mb: 1, fontSize: "1.05rem" }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#666", lineHeight: 1.7 }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        
        <TradingDetailsBox/>
      </Container>
        </>
    );

}
export default SecurityOfFunds;
